import * as React from 'react';
import { SelectVehicleHelperProps, InitialSelectVehicleHelperProps } from './HelperProps';
import { BaseEntityService } from '../../../BaseEntity/BaseEntityService';
import { IBaseEntityProps } from '../../../BaseEntity/IBaseEntityProps';
import i18next from '../../../../i18n';
import { IEntityReducer } from '../../../BaseEntity/IEntityReducer';
import { IVolmaTableColumn } from '../../../../Table/VolmaTable/IVolmaTableProps';
import { VolmaContainer } from '../../../../../Infrastructure/InversifyInject';
import { VolmaTableService } from '../../../../../Infrastructure/Services/VomaTableService';
import { Types } from '../../../../../Infrastructure/Types';
import { volmaBlock } from '../../../../../Infrastructure/Services/BEM';
import VolmaSelect from '../../../../VolmaSelect/index';
import PropertyHelper from '../../../../../Infrastructure/Services/PropertyHelper';
import { SelectVehicleDTO } from './SelectVehicleDTO';
import { SelectVehicleReducer } from './SelectVehicleReducer';
import { SelectVehicleActions } from './SelectVehicleActions';
import { VehicleTableDTO } from '../../../../../Domain/DTO/VehicleTableDTO';

export class SelectVehicleEntityService extends BaseEntityService<SelectVehicleDTO, SelectVehicleHelperProps>{
    private _volmaTableService: VolmaTableService;
    private _dispatch: any;

    private _reducer: SelectVehicleReducer;
    private _actions: SelectVehicleActions;

    private _moreInfo = volmaBlock("more-info");

    constructor() {
        super();

        this._volmaTableService = VolmaContainer.get<VolmaTableService>(Types.VolmaTableService);
        this._reducer = VolmaContainer.get<SelectVehicleReducer>(Types.SelectVehicleReducer);
        this._actions = VolmaContainer.get<SelectVehicleActions>(Types.SelectVehicleActions);
    }

    public GetColumnsList(): Array<IVolmaTableColumn> {
        return [];
    }

    public GetEditorModal(props: IBaseEntityProps<SelectVehicleDTO, SelectVehicleHelperProps>): JSX.Element {
        return (
            <div>
                <div className={(this._mainInfo("item")).toString()}>
                    <div className={(this._container()).toString()}>
                        <div className={(this._mainInfo("row")).toString()}>
                            <div className={this._mainInfo("cell", { full: true, 100: true }).toString()}>
                                <div className={this._mainInfo("line", { fill: true }).toString()}>
                                    <VolmaSelect
                                        {...(PropertyHelper.GetSelectPropertyByName(props.Selects, (val: SelectVehicleDTO) => val.SelectedVehicle) as any) }
                                        Name={PropertyHelper.GetPropertyName((x: SelectVehicleDTO) => x.SelectedVehicle)}
                                        Label={i18next.t("selectvehicle:Vehicle")}
                                        Placeholder={i18next.t("selectvehicle:SelectVehicle")}
                                        Options={props.DataHelper.VehicleList}
                                        LabelKey={PropertyHelper.GetPropertyName((x: VehicleTableDTO) => x.Name)}
                                        ValueKey={PropertyHelper.GetPropertyName((x: VehicleTableDTO) => x.Id)}
                                        Value={props.DataHelper.SelectedVehicle}
                                        HelperFieldName={PropertyHelper.GetPropertyName((val: SelectVehicleHelperProps) => val.SelectedVehicle)}
                                        HelperFieldToDTOFieldTranslator={(x: VehicleTableDTO) => x}
                                        Required={true}
                                        dispatch={props.dispatch} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public GetEditor(props: IBaseEntityProps<SelectVehicleDTO, SelectVehicleHelperProps>): JSX.Element {
        return (
            <span>
            </span>
        );
    }

    public InitializeEntity(props: IBaseEntityProps<SelectVehicleDTO, SelectVehicleHelperProps>): void {
        this._dispatch = props.dispatch;
        this._dispatch(this._actions.LoadAllVehicles(i18next.t("common:Loading")));
    }

    public OnAfterDataLoaded(dto: any): void {
    }

    public GetReducer(): IEntityReducer<SelectVehicleDTO, SelectVehicleHelperProps> {
        return this._reducer;
    }

    public GetInitialDataHelper(): SelectVehicleHelperProps {
        return InitialSelectVehicleHelperProps;
    }
}